export const isChannelActivated = (campaign, channel) => {
  return Object.keys(campaign.channels || {})
    .slice(0, 4)
    .filter((channel) => campaign.channels[channel])
    .includes(channel)
}
